// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/carnas-regular/carnas_regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/carnas-regular/carnas_regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "carnas-regular";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
	font-weight: normal;
	font-style: normal;
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/notosans/v30/o-0IIpQlx3QUlC5A4PNr5TRA.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: 'Noto Sans Display';
  font-style: bold;
  font-weight: 400;
  font-stretch: 100%;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKZTaa2w.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.Box-container {
	position: absolute;
	width: 50%;
	height: 100%;
	left: 0px;
	top: 0px;
	align-items: center;
	background: #3d3d8f;
	border: 1px solid rgba(0, 0, 0, 0.161);
	box-shadow: 4px 0px 16px rgba(0, 0, 0, 0.25);
}

.page-content {
	padding-top: 70px;
}

.image-container {
	top: 10em;
}

.image-logo {
  width:80%;
	top: 40%;
  left: 10%;
  position: absolute;
  object-fit: contain;
}

.login-section {
	margin-top: 17%;
	margin-left: 17%;
	display: grid;
	position: relative;
	width: 18em;
	height: 89px;
	justify-items: start;
	align-items: center;
	align-content: space-between;
}

.login-text {
	font-family: "Noto Sans Display";
	font-size: 30px;
	margin: 0;
}

.text-space {
	font-family: "Noto Sans";
	font-size: 15px;
	margin: 0.5px;
	margin-top: 20px;
	margin-bottom: 7px;
}

.text-input {
	width: 155%;
}

.login-button {
	display: flex;
	padding-top: 40px;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	position: absolute;
	width: 155%;
	height: 55%;
}

.login-button:hover {
	background-color: yellow;
}
`, "",{"version":3,"sources":["webpack://./src/views/style.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B;;wDAE0E;CAC1E,mBAAmB;CACnB,kBAAkB;AACnB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iGAAiG;EACjG,iMAAiM;AACnM;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sJAAsJ;EACtJ,iMAAiM;AACnM;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,mBAAmB;CACnB,mBAAmB;CACnB,sCAAsC;CACtC,4CAA4C;AAC7C;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,SAAS;AACV;;AAEA;EACE,SAAS;CACV,QAAQ;EACP,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,SAAS;AACV;;AAEA;CACC,wBAAwB;CACxB,eAAe;CACf,aAAa;CACb,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,wBAAwB;AACzB","sourcesContent":["@font-face {\n\tfont-family: \"carnas-regular\";\n\tsrc: url(\"../fonts/carnas-regular/carnas_regular-webfont.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../fonts/carnas-regular/carnas_regular-webfont.woff\") format(\"woff\");\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v30/o-0IIpQlx3QUlC5A4PNr5TRA.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n@font-face {\n  font-family: 'Noto Sans Display';\n  font-style: bold;\n  font-weight: 400;\n  font-stretch: 100%;\n  src: url(https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKZTaa2w.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n.Box-container {\n\tposition: absolute;\n\twidth: 50%;\n\theight: 100%;\n\tleft: 0px;\n\ttop: 0px;\n\talign-items: center;\n\tbackground: #3d3d8f;\n\tborder: 1px solid rgba(0, 0, 0, 0.161);\n\tbox-shadow: 4px 0px 16px rgba(0, 0, 0, 0.25);\n}\n\n.page-content {\n\tpadding-top: 70px;\n}\n\n.image-container {\n\ttop: 10em;\n}\n\n.image-logo {\n  width:80%;\n\ttop: 40%;\n  left: 10%;\n  position: absolute;\n  object-fit: contain;\n}\n\n.login-section {\n\tmargin-top: 17%;\n\tmargin-left: 17%;\n\tdisplay: grid;\n\tposition: relative;\n\twidth: 18em;\n\theight: 89px;\n\tjustify-items: start;\n\talign-items: center;\n\talign-content: space-between;\n}\n\n.login-text {\n\tfont-family: \"Noto Sans Display\";\n\tfont-size: 30px;\n\tmargin: 0;\n}\n\n.text-space {\n\tfont-family: \"Noto Sans\";\n\tfont-size: 15px;\n\tmargin: 0.5px;\n\tmargin-top: 20px;\n\tmargin-bottom: 7px;\n}\n\n.text-input {\n\twidth: 155%;\n}\n\n.login-button {\n\tdisplay: flex;\n\tpadding-top: 40px;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: absolute;\n\twidth: 155%;\n\theight: 55%;\n}\n\n.login-button:hover {\n\tbackground-color: yellow;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
